import { createAction, props } from '@ngrx/store';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';



export const addCurrencyExchange = createAction(
  '[Currency] updateCurrencyExchange',
  props<{ currency: CurrencyExchange }>()
)
